// extracted by mini-css-extract-plugin
export default {"round":"Flag_round__YEmaJ"};